import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_PRICING_MUTATION = gql`
  mutation updatePricing(
    $documentVersion: DocumentVersionInput!,
    $lineId: String!,
    $priceLineId: String!,
    $stepId: String!,
    $rate: Decimal!,
    $withPricing: Boolean = true
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          setPricingCommand(priceLineId: $priceLineId, stepId: $stepId, rate: $rate) {
            documentId
            revision
            status
            snkModifier {
              profile {
                firstName
                lastName
              }
            }
            lines {
              id
              ...ProductLinePricingFragment @include(if: $withPricing)
              ...CustomLinePricingFragment @include(if: $withPricing)
            }
            ...QuotePricingFragment @include(if: $withPricing)
            ...QuotePricingStateFragment @skip(if: $withPricing)
          }
        }
      }
    }
  }
  ${PRODUCT_LINE_PRICING_FRAGMENT}
  ${CUSTOM_LINE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdatePricingMutation extends Mutation<RootMutation> {
  document = UPDATE_PRICING_MUTATION;
}
